import PageHeader from "../../pageheader/PageHeader";
import { useNavigate } from "react-router-dom";
import step1 from "../../../asset/icon/step1.svg";
import step2 from "../../../asset/icon/step2.svg";
import step4 from "../../../asset/icon/step4.svg";
import step5 from "../../../asset/icon/step5.svg";
import step6 from "../../../asset/icon/step6.svg";
import { environment } from "../../../config.env";
import * as MedicalApi from '../../../service/medicalApi';

export function BannerSearchSteps() {
  const navigate = useNavigate();
  const dataSteps = [
    {
      icon: step1,
      title: "เจ้าหน้าที่เสียบบัตรประชาชนที่จุดรับบริการ",
    },
    {
      icon: step2,
      title:
        "เจ้าหน้าที่กรอกหมายเลขโทรศัพท์ผู้ยินยอมสิทธิ์สำหรับการยืนยันตัวตนด้วยรหัส OTP",
    },
    {
      icon: step4,
      title: "เจ้าหน้าที่กดอนุญาต/ไม่อนุญาตสิทธิ์การเข้าถึงข้อมูล",
    },
  ];

  const getSiamScanCard = async () => {
    await MedicalApi.getSiamScanCard()
  }

  const getSiamScanCardManual = async () => {
    await MedicalApi.getSiamScanCardManual();
  }

  return (
    <>
      <div className="lg:!px-[60px] px-[120px] pb-[60px] bg-[#F6FAFF] mt-4">
        {/*  */}
        <div className="py-2">
          <PageHeader titlename="ขั้นตอนการใช้งานค้นหาข้อมูลผู้ป่วยแบบใช้บัตรประชาชน" />
        </div>
        <div className="grid md:grid-cols-1 grid-cols-3 gap-10 mt-2 mb-4">
          {dataSteps.map((item, index) => (
            <div key={index} className="flex flex-col gap-4">
              <div className="flex justify-center">
                <img src={item.icon} alt="Icon" />
              </div>
              <span className="w-full text-center text-[#03509C] text-[18px]">
                {index + 1}. {item.title}
              </span>
            </div>
          ))}
        </div>

        <div className="w-full bg-[#ffffff] rounded-lg shadow-lg flex md:flex-col px-6 md:gap-4 py-10 items-center mb-6 justify-between md:text-center">
          <div className="flex md:flex-col gap-2 md:items-center">
            <img src={step5} alt="Step Information" className="max-w-[70px]" />
            <div className="ms-4">
              <span className="text-[30px] font-bold">
                ขอดูข้อมูลผู้ป่วยด้วยบัตรประชาชน
              </span>
              <br />
              <span className="text-[#03509c]">
                ต้องการสิทธฺ์การเข้าถึงข้อมูลด้วยบัตรประชาชน (ID Card) หรือไม่ ?
                คลิกเพื่อกรอกหมายเลขบัตรประชาชนใช้งาน
              </span>
            </div>
          </div>

          <button
            className="p-4 bg-[#03509c] rounded-md text-[#ffffff] flex gap-2 items-center"
            onClick={() =>
              navigate(`/search-for-patient-information/IDcard-request-data`)
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 576 512"
              width="24"
              height="24"
            >
              <path
                fill="#FFFFFF"
                d="M0 96l576 0c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm0 32L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-288L0 128zM64 405.3c0-29.5 23.9-53.3 53.3-53.3l117.3 0c29.5 0 53.3 23.9 53.3 53.3c0 5.9-4.8 10.7-10.7 10.7L74.7 416c-5.9 0-10.7-4.8-10.7-10.7zM176 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm176 16c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z"
              />
            </svg>
            ขอเข้าถึงข้อมูลด้วยบัตรประชาชน
          </button>
        </div>

        <div className="w-full bg-[#FFFAE9] rounded-lg shadow-lg flex md:flex-col md:gap-4 px-6 py-10 items-center mb-6 justify-between md:text-center">
          <div className="flex md:flex-col md:items-center gap-2 items-center">
            <img src={step6} alt="Step Information" className="max-w-[70px]" />
            <div className="ms-4">
              <span className="text-[30px] font-bold">โปรแกรมเสียบบัตร</span>
              <br />
              <span className="text-[#EB531A]">
                ต้องการใช้งานระบบยืนยันตัวตนด้วยการเสียบบัตรประชาชนหรือไม่ ? 
                 <span className="cursor-pointer hover:underline ml-[6px]" tagget="_blank" onClick={() => getSiamScanCardManual()}>คลิกเพื่อดูคำแนะนำการใช้งาน</span>
              </span>
            </div>
          </div>

          <button
            className="p-4 bg-[#EB531A] rounded-md text-[#ffffff] flex items-center justify-center gap-2 text-[1rem]"
            onClick={() => getSiamScanCard()}
          >
            <span className="text-[1.15em]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                width="1em"
                height="1em"
              >
                <path
                  fill="#FFFFFF"
                  d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 242.7-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7 288 32zM64 352c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-101.5 0-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352 64 352zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                />
              </svg>
            </span>
            <span>ดาวน์โหลดโปรแกรมเสียบบัตร</span>
          </button>
        </div>
      </div>
    </>
  );
}
